import { Flex, Typography } from 'antd'
import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { TRANSACTION_STATUS_LABEL } from '../index.constant'
import {
  colorBgButtonSubtleHovered,
  colorBgErrorBold,
  colorBgErrorHovered,
  colorBgSuccessHovered,
  colorBgWarningHovered,
  colorBorderInfo,
  colorTextSubtle,
  success,
  warning,
} from 'src/app/themes/primaryThemeDefault'

export interface IStatusTag {
  status: string
}

const StatusTag: React.FC<IStatusTag> = (props) => {
  const { status } = props
  const { t } = useTranslation()

  const getConfig = useCallback(
    (status: string) => {
      switch (status) {
        case TRANSACTION_STATUS_LABEL.EXCEPTION:
          return {
            color: warning,
            backgroundColor: colorBgWarningHovered,
            text: t(`AllTransactions:viewTransaction.status_list.exception`),
          }
        case TRANSACTION_STATUS_LABEL.TRUE:
          return {
            color: success,
            backgroundColor: colorBgSuccessHovered,
            text: t(`AllTransactions:viewTransaction.image_found_status.true`),
          }
        case TRANSACTION_STATUS_LABEL.ISSUED:
          return {
            color: success,
            backgroundColor: colorBgSuccessHovered,
            text: t(`AllTransactions:viewTransaction.status_list.issued`),
          }
        case TRANSACTION_STATUS_LABEL.OUTSTANDING:
          return {
            color: '#7D45FF',
            backgroundColor: '#EFE9FF',
            text: t(`AllTransactions:viewTransaction.status_list.outstanding`),
          }
        case TRANSACTION_STATUS_LABEL.FALSE:
          return {
            color: colorTextSubtle,
            backgroundColor: colorBgButtonSubtleHovered,
            text: t(`AllTransactions:viewTransaction.image_found_status.false`),
          }
        case TRANSACTION_STATUS_LABEL.PAID:
          return {
            color: colorBorderInfo,
            backgroundColor: '#EDF9FF',
            text: t(`AllTransactions:viewTransaction.status_list.paid`),
          }
        case TRANSACTION_STATUS_LABEL.RETURNED:
          return {
            color: colorBgErrorBold,
            backgroundColor: colorBgErrorHovered,
            text: t(`AllTransactions:viewTransaction.status_list.returned`),
          }
        case TRANSACTION_STATUS_LABEL.STOP_PAYMENT:
          return {
            color: '#F8C100',
            backgroundColor: '#FFFAE7',
            text: t(`AllTransactions:viewTransaction.status_list.stop`),
          }
        case TRANSACTION_STATUS_LABEL.VOID:
          return {
            color: colorTextSubtle,
            backgroundColor: colorBgButtonSubtleHovered,
            text: t(`AllTransactions:viewTransaction.status_list.void`),
          }
        default:
          return {
            color: '',
            backgroundColor: '',
            text: '',
          }
      }
    },
    [t],
  )

  const configs = useMemo(() => getConfig(status), [getConfig, status])

  if (!status) {
    return <div />
  }

  return (
    <Flex
      style={{
        borderRadius: 27,
        padding: '4px 12px',
        backgroundColor: configs.backgroundColor,
        width: 'fit-content',
        alignItems: 'center',
        gap: 4,
      }}
    >
      <div
        style={{
          backgroundColor: configs.color,
          minWidth: 4,
          width: 4,
          height: 4,
          borderRadius: 50,
        }}
      />
      <Typography
        style={{
          color: configs.color,
          fontSize: 14,
          fontWeight: 700,
          wordBreak: 'keep-all',
        }}
      >
        {configs.text}
      </Typography>
    </Flex>
  )
}

export default StatusTag
